import { get } from "../../utils/object-helpers";

<if(input)>
    $ {
        const title = get(input, "title", {});
        const { protocol, hostname } = new URL(get(input, "action.URL", ""));
    }

    <aside class="str-survey">
        <a href="#" id="str-survey">
            <str-textual-display ...title />
            <span>
                <ebay-thumb-up-24-icon />
                <ebay-thumb-down-24-icon />
            </span>
        </a>
    </aside>
    <script type="text/javascript" src=`${protocol}//${hostname}/srv/app/v2/plugin/survey-modal.js`></script>
</if>
